import { OrthographicCamera } from "three";
import { ZoomPanBehaviour } from "../../behaviors/internal";
import { Camera } from "./internal";
/**
 * Quadtree camera. Derived class
 *
 * @class QuadtreeCamera
 * @param {SceneGraphNode} parentNode
 * @extends {Camera}
 * @constructor
 */
export class QuadtreeCamera extends Camera {
    constructor(parentNode) {
        super(parentNode); //call super-class constructor
    }
    /**
     * writes: traversalstate.quadtreecamera
     *
     * @method init
     * @param {TraversalState} traversalState
     */
    init(traversalState) {
        const scene = traversalState.scene;
        this.iCamera = new OrthographicCamera(scene.engine.getContextWidth() / -2, scene.engine.getContextWidth() / 2, scene.engine.getContextHeight() / 2, scene.engine.getContextHeight() / -2, 0, 1000);
        this.iCamera.position.z = 1000;
        this.iCamera.position.y = 0;
        this._zoomPanBehavior = new ZoomPanBehaviour(this);
        this.addBehavior(this._zoomPanBehavior);
        super.init(traversalState);
    }
    getWidth() {
        return this.iCamera.fullWidth;
    }
    getHeight() {
        return this.iCamera.fullHeight;
    }
    resetZoomPan() {
        this._zoomPanBehavior.reset();
    }
    setZoomPan(zoom, panX, panY) {
        this._zoomPanBehavior.setZoomPan(zoom, panX, panY);
    }
    getZoomPan() {
        return this._zoomPanBehavior.getZoomPan();
    }
}
//# sourceMappingURL=quadtreecamera.js.map